import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AddclinicianUserPayload, Clinician, GetCliniciansUserResponse } from 'app/shared/models/clinician.model';
import { config } from 'config';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export interface GetCliniciansResponse {
  clinicians: Clinician[]
}
@Injectable({
  providedIn: 'root'
})
export class ClinicianService {

  constructor(private http: HttpClient) { }

  getClinicians(data?: any): Observable<GetCliniciansResponse> {
    const url = config.apiUrl1 + 'clinicians';
    const options = data ? { params: data } : {};
    return this.http.get<GetCliniciansResponse>(url, options);
  }

  createClinician(data: AddclinicianUserPayload) {
    return this.http.post<any>(`${config.apiUrl1}clinicians/store`, data);
  }
  getClinicianById(id: number): Observable<any> {
    const url = `${config.apiUrl1}clinicians/${id}`;
    return this.http.get<any>(url).pipe(
      catchError(err => throwError(err))
    );
  }

  updateClinician(id: number, data: any): Observable<any> {
    const url = `${config.apiUrl1}clinicians/update/${id}`;
    return this.http.post<any>(url, data);
  }
  addClinician(data: any): Observable<any> {
    const url = `${config.apiUrl1}clinicianExcludedLocation/store`;
    return this.http.post<any>(url, data).pipe(
      catchError(err => throwError(err))
    );
  }

  deleteClinicianLocation(id: number): Observable<any> {
    const url = `${config.apiUrl1}clinicianExcludedLocation/delete/${id}`;
    return this.http.get<any>(url).pipe(
      catchError(err => throwError(err))
    );
  }

  updateClinicianStatus(clinicianId: number, status: 0 | 1): Observable<any> {
    const url = `${config.apiUrl1}clinicians/updateStatus/${clinicianId}/${status}`;
    return this.http.get<any>(url).pipe(
      catchError(err => throwError(err))
    );
  }
  
  updateClinicianImage(data: any): Observable<any> {
    const url = `${config.apiUrl1}updateProfilePicture`;
    return this.http.post<any>(url, data);
  }

}
